import { AggregationRequest } from "./AggregationRequest";
import { JobDescriptionKeys } from "./JobDescriptionKeys";

export class TIAggRequest implements AggregationRequest {
    aggregatetype: string;
    startindex: any;
    resultsize: any;
    searchviaboolean: boolean = true;
    booleanquery: string = "*";
    jobtitles: any[] = [];
    exclude_pastjobtitles?: string[];
    preferredskills?: string[];
    mandatoryskills: Array<any> = [];
    locations: Array<any> = [];
    continentstobeincluded: Array<any> = [];
    companies: Array<any> = [];
    industries: Array<any> = [];
    exclusionlist: Array<any> = [];
    genders: Array<any> = ["All"];
    seniority: Array<any> = ["All"];
    graduationyear: Array<any> = [];
    schools: Array<any> = [];
    schooltypes: Array<any> = [];
    educationaldegrees: Array<any> = [];
    educationalmajors: Array<any> = [];
    candidateshavingemails: boolean = false;
    candidateshavingcontactnumbers: boolean = false;
    minexperience: any | null = null;
    maxexperience: any | null = null;
    minexperienceinccurrentcompany: any | null = null;
    zipcodes: Array<any> = [];
    companysizes: Array<any> = ["All"];
    candidateshavingcontacts: boolean = false;
    workregions: Array<any> = [];
    workcountries: Array<any> = [];
    worklocalities: Array<any> = [];
    spokenlanguages: Array<any> = [];
    contacts: Array<any> = ["All"];
    candidateshavingmobilenumber: boolean = false;
    candidateshavingpersonalemail: boolean = false;
    candidateshavingprofessionalemail: boolean = false;
    candidateshavingsocialprofiles: boolean = false;
    fromgraduationyears: Array<any> = [];
    tograduationyears: Array<any> = [];
    exclude_jobtitles: Array<any> = [];
    exclude_companies: Array<any> = [];
    exclude_locations: Array<any> = [];
    companytype: string = "Current";
    jobtitletype: string = "Current";
    industrytype: string = "Current";
    fromyearsofexperience: Array<any> = [];
    toyearsofexperience: Array<any> = [];
    experiencetype: string = "Total";
    likelytomovetype: null | string = null;
    salaries: Array<any> = ["All"];
    salaryranges: Array<any> = ["All"];
    functions: Array<any> = [];
    aggregatescount?: number;
    needcuratedtalentpooltags?: boolean;
    insightspastjobtitles?: string[];
    searchedfrom?: string;
    job_description_keys?: JobDescriptionKeys;
    durationinmonths?: number;
    ids?: any[];
    // distancefromselectedlocationsmeasurementunit?: string = 'kilometer';
    // distancefromselectedlocations?: number = 20;
}
  